import {SummaryType} from '@ls/grouping-service';
import {selectGetGroupingParams} from 'state/selections/selectors';
import {splitByCalcType} from 'state/util';
import scope from './scope';
import SelectionState from "state/selections/SelectionState";
import {selectDefinitions} from "./selectors";
import {exchange} from '@ls/js-fetch';

export const DELETE_DEFINITION = `${scope}/DELETE_DEFINITION`;
export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const requestGridData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const definitions = selectDefinitions(SelectionState.COMMITTED)(state);
    if (!definitions?.length) {
      return;
    }
    const [absDefinitions, bmkDefinitions, relDefinitions] = splitByCalcType(definitions);
    const getGroupingParams = selectGetGroupingParams(SelectionState.COMMITTED)(state);

    const request = async (summary, definitions, benchesToo) => {
      dispatch({type: REQUEST_DATA, summary});

      const params = getGroupingParams({
        summary,
        benchesToo,
        results: ['ISSUER_COUNT'],
      });

      dispatch({
        type: RECEIVE_DATA,
        summary,
        data: (await exchange({
          params,
          cancelId: `data-${scope}-${summary}`,
          url: process.env.REACT_APP_BASE_URL_GROUPING_SERVICE,
        }))?.data,
      });
    };
    if (absDefinitions.length || bmkDefinitions.length) {
      request(
        SummaryType.ABSOLUTE,
        [...absDefinitions, ...bmkDefinitions],
        bmkDefinitions.length > 0,
      ).then()
    }

    if (relDefinitions.length) {
      request(
        SummaryType.RELATIVE,
        relDefinitions,
        true,
      ).then()
    }
  };
};